export default __webpack_public_path__ + "static/media/pak2.e9a3a1be.jpg";